import { render, staticRenderFns } from "./PageEditorPageSettings.vue?vue&type=template&id=010c2e2e&scoped=true"
import script from "./PageEditorPageSettings.vue?vue&type=script&lang=js"
export * from "./PageEditorPageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c2e2e",
  null
  
)

export default component.exports